import { useId } from "react";

const LEAF = "M50 48 C40 42 25 33 25 21 C25 12 32 7 39 7 C44 7 48 10 50 14 C52 10 56 7 61 7 C68 7 75 12 75 21 C75 33 60 42 50 48 Z";

export const CloverLogo = ({ className = "h-9 w-9", testid = "clover-logo" }) => {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 100 100" className={className} data-testid={testid} role="img" aria-label="Clover Management">
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FF7A8F" />
          <stop offset="55%" stopColor="#E11D5A" />
          <stop offset="100%" stopColor="#B80F45" />
        </linearGradient>
        <linearGradient id={`h${id}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>
      {[0, 90, 180, 270].map((r) => (
        <g key={r} transform={`rotate(${r} 50 50)`}>
          <path d={LEAF} fill={`url(#g${id})`} stroke="#A30D3D" strokeWidth="1.6" strokeLinejoin="round" />
          <path d="M34 14 C38 11 44 12 46 17 C40 16 36 18 33 22 C32 19 32 16 34 14 Z" fill={`url(#h${id})`} />
        </g>
      ))}
      <circle cx="50" cy="50" r="4.5" fill="#fff" />
    </svg>
  );
};
